import {takeEvery} from 'redux-saga/effects'
import {GET_ADMISSION_VOUCHERS} from 'setup/redux/Actions/AdmissionVoucher/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* admissionVoucherSaga() {
  yield takeEvery(GET_ADMISSION_VOUCHERS, fetchData)
}

export default admissionVoucherSaga
